import React from "react";
import { Avatar, Stack, Typography, Chip, Box } from "@mui/material";
import { Images } from "../../assets/common";
import moment from "moment";

import UnsubscribePopup from "../UnsubscribePopup";
import { formatedDate } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function SubscriptionRow({
  title,
  status,
  action,
  actionColor,
  statusColor,
  data,
  onAction,
  index,
}) {
  const { t } = useTranslation("common");
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    if (data.endDate && data["status"] != "Active") setOpen(false);
    else setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
    if (e) onAction(e);
  };

  return (
    <Stack direction="row" alignItems="start" padding="0 16px">
      <Avatar
        className="avatar"
        src={
          data["artistDetails"]
            ? data["artistDetails"].profileImg.filePath
            : Images.rectangle
        }
      />
      <Stack
        direction="column"
        // justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ width: "100%" }}
        >
          <Stack sx={{ marginRight: "auto", marginLeft: "10px" }}>
            <Typography>{title}</Typography>
            <Chip
              sx={{
                height: "17px",
                fontStyle: "italic",
                fontSize: "12px",
                width: "max-content",
              }}
              label={status}
              color={action === "Unsubscribed" ? "error" : "success"}
            />
          </Stack>
          <Stack>
            <Chip
              label={
                data.endDate && data["status"] != "Active"
                  ? t("mySubscription.button.unsubscribe")
                  : action === "Unsubscribed"
                  ? t("mySubscription.button.subscribe")
                  : t("mySubscription.button.unsubscribe")
              }
              color={action === "Unsubscribed" ? "default" : "error"}
              variant="outlined"
              className="-cp"
              onClick={handleClickOpen}
              sx={{
                minWidth: "110px",
                cursor: action === "Unsubscribed" ? "not-allowed" : "pointer",
              }}
            />
            {data["endDate"] ? (
              <Typography color="primary" className="fs-12 text-right">
                {t("mySubscription.subscriptionText")}{" "}
                {formatedDate(data["endDate"])}
              </Typography>
            ) : null}
          </Stack>
        </Stack>
        {status === "Stopped" ? (
          <Typography
            sx={{
              color: "#FFFFFF80",
              fontSize: "12px !important",
              margin: ".5rem 0 !important",
            }}
          >
            {t("mySubscription.status.stopped")}
          </Typography>
        ) : null}
      </Stack>
      <UnsubscribePopup
        action={
          action === "Unsubscribed"
            ? t("mySubscription.button.subscribe")
            : t("mySubscription.button.unsubscribe")
        }
        open={open}
        handleClose={(e) =>
          e ? handleClose(data["artistDetails"]["_id"], index) : handleClose()
        }
      />
    </Stack>
  );
}
